import React from "react";
import { VstLoader, VstButton } from "vstui";
import Decks from "./decks";
import Deck from "./deck";
import { Isvg } from "../../components";

const Body = ({
  adding,
  cancel,
  close,
  currentDeck,
  decks,
  findValue,
  newCardFront,
  isbn,
  selectCurrentDeck,
  showOnboarding
}) => {
  if (!decks) {
    return (
      <div id="flashcards waiting">
        <VstLoader />
      </div>
    );
  } else if (currentDeck) {
    return (
      <Deck
        adding={adding}
        cancel={cancel}
        close={close}
        uuid={currentDeck.uuid}
        findValue={findValue}
        newCardFront={newCardFront}
        isbn={isbn}
      />
    );
  } else if (decks.length > 0 || adding) {
    return (
      <Decks
        adding={adding}
        cancel={cancel}
        decks={decks}
        isbn={isbn}
        onClick={selectCurrentDeck}
      />
    );
  } else {
    return (
      <div className="null-screen-container">
        <div className="null-screen">
          {Fraction.Brand.Graphics.watkins && (
            <Isvg className="watkins null" src="/img/watkins_search.svg" />
          )}
          <h3 className="title">
            {i18n.t("reader.flashcards.create-new-deck")}
          </h3>
          <p className="instructions">
            {i18n.t("reader.flashcards.use-button")}
          </p>
          <VstButton options="btn-32" onClick={showOnboarding}>
            {i18n.t("base.learn-more")}
          </VstButton>
        </div>
      </div>
    );
  }
};

export default Body;
